import { MessageText } from "../../constants/constants.js";

const TEXT = MessageText.statusScreens.unknown;

export default function UnknownStatusScreen({
  heading = TEXT.heading,
  message = TEXT.message,
}) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center bg-gray-50">
      <h1 className="text-xl font-bold text-gray-800">{heading}</h1>
      <p className="text-gray-600 max-w-md leading-relaxed">{message}</p>
    </div>
  );
}
